class LookbookSocialSharing extends HTMLElement {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    const shareButton = event.target.closest('[data-lookbook-social-sharing-el="share"]');

    if (!shareButton || !this.contains(shareButton)) {
      return;
    }

    if (typeof navigator.share === 'function') {
      try {
        navigator.share({
          title: this.dataset.shareTitle,
          url: this.dataset.shareUrl
        }).catch((error) => {
          if (!error || error.name !== 'AbortError') {
            this.showStatus(this.dataset.shareFallback);
          }
        });
      } catch (error) {
        this.showStatus(this.dataset.shareFallback);
      }

      return;
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(this.dataset.shareUrl)
        .then(() => this.showStatus(this.dataset.shareSuccess))
        .catch(() => this.showStatus(this.dataset.shareFallback));
      return;
    }

    this.showStatus(this.dataset.shareFallback);
  }

  showStatus(message) {
    const status = this.querySelector('[data-lookbook-social-sharing-el="status"]');

    if (!status) {
      return;
    }

    status.hidden = false;
    status.textContent = message;
  }
}

if (!customElements.get('lookbook-social-sharing')) {
  customElements.define('lookbook-social-sharing', LookbookSocialSharing);
}
